var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',[_c('p',[_vm._v(_vm._s(_vm.$t('page404Msg')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }